import React, { useEffect, useState } from "react";
import { Modal, Form, FormControl } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { loadMenteeLogs, loadRegMenteeLogs } from "../../Pages/MenteesLog/Slice/menteesLogSlice";
import { useDispatch, useSelector } from "react-redux";
import { loadMentorList } from "../../Pages/DashboardMentor/Slice/dashboardMentorSlice";
import PropTypes from "prop-types";
import { loadRegMyMentors } from "../../Pages/MyMentors/Slice/myMentorsSlice";

const MentoringSession = (props) => {

  const dispatch = useDispatch();
  const { userdata } = props;
  const { isAuth } = useSelector((state) => state?.user);
  const userInfo = useSelector((state) => state?.userInfo);
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const [roleSession, setRoleSession] = useState()
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(false);

  console.log("", roleSession);

  useEffect(() => {
    const sessions =
      userInfo?.role_id === "Mentor"
        ? userdata?.mentor_sessions
        : userdata?.mentee_sessions;

    setRoleSession(sessions);

    setValue("sessions", sessions); // <-- sync RHF value
  }, [userdata, userInfo, setValue]);

  const onSubmit = async (data) => {
    const request = { sessions: data.sessions };
    try {
      setLoading(true);
      const res = await agent.post(
        `${API.LOAD_CUSTOMER}/update-session/${userInfo?.id}/${userdata?.id}`,
        request
      )
      setPopupMessage(res.data.message);
      setShowPopup(true);

      dispatch(
        loadRegMyMentors({
          request,
          userId: userInfo.id,
          roleId: userInfo.role_id,
        })
      );
    } catch (err) {
      setPopupMessage(err.res.data.message || "Something went wrong. Please try again.");
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setShowPopup(false);
    props.onHide(); // close parent modal

    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const requestParams = {};

    if (params.get("sort")) {
      requestParams.sort = queryStringParsed["sort"];
      requestParams.direction = queryStringParsed["direction"];
    }

    if (params.get("page")) {
      requestParams.page = queryStringParsed["page"];
    }

    if (params.get("keyword")) {
      requestParams.keyword = queryStringParsed["keyword"];
    }

    if (userInfo?.role_id === "Mentor") {
      if (typeof props.refreshMentors === "function") {
        props.refreshMentors();
      } else {
        dispatch(loadRegMenteeLogs({ request: requestParams, status: 4 }));
      }
    } else {
      dispatch(
        loadMentorList({
          request: requestParams,
          domains: isAuth ? userInfo?.domains : "",
          user_id: userInfo?.id || 0,
          role_id: userInfo?.role_id || 0,
        })
      );
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton>Mentoring Sessions</Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} className="banner_form2 signup_class">
            <Form.Group controlId="formSessions" style={{ marginTop: '1rem' }} className="mb-4">
              <FormControl
                type="number"
                min={1}
                max={10000}
                placeholder="No. of mentoring sessions completed"
                className={errors.sessions ? "formError" : ""}
                name="sessions"
                aria-invalid={errors.sessions ? "true" : "false"}
                {...register("sessions", { required: true })}
              />
              {errors?.sessions && errors?.sessions?.type === "required" && (
                <span role="alert" className="err_msg">
                  Please enter no. of sessions
                </span>
              )}
            </Form.Group>
            <div className="text-end">
              <button type={"submit"} className={"btn btn-signup px-4 ms-auto"} disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </Form>
        </Modal.Body >
      </Modal >
      <PopupModalWithOk
        show={showPopup}
        onHide={handlePopupClose}   // ✅ clean & reusable
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

MentoringSession.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  userdata: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mentor_sessions: PropTypes.number,
    mentee_sessions: PropTypes.number,
  }).isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role_id: PropTypes.string,
  }).isRequired,
  refreshMentors: PropTypes.func.isRequired
};

export default MentoringSession;
